import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import PanelSearchEmail from '../search/PanelSearchEmail'
import TableBlock from './TableBlock'

function PanelBlockEmail({
  classes,
  email,
}) {
  return (
    <PanelSearchEmail
      email={email}
      TableComponent={TableBlock} />
  )
}

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default withStyles(styles)(PanelBlockEmail)